import unit_trust_intro from "assets/images/unit_trust_intro.jpg";
import unit_trust_benefits from "assets/images/unit_trust_benefits.svg";
import hajj_knowledge from "assets/images/hajj_knowledge.svg";
import sinar_baraqah_benefit from "assets/images/table/sinar_baraqah_benefit.svg";
import sinar_health_plan from "assets/images/sinar_health_plan.svg";
import sinar_health_plan_table from "assets/images/table/sinar_health_plan_table.svg";
import safe_deposit_box_KL_rates from "assets/images/table/safe_deposit_box_KL_rates.svg";
import safe_deposit_box_KK_rates from "assets/images/table/safe_deposit_box_KK_rates.svg";
import safe_deposit_box_ipoh_rates from "assets/images/table/safe_deposit_box_ipoh_rates.svg";
import safe_deposit_box_other_charges from "assets/images/table/safe_deposit_box_other_charges.svg";
import { Link } from "react-router-dom";

const wealth = {
  gold: {
    about: {
      description: `<p>Proven over centuries to be able to protect the real value of money, investment in gold will lead to the creation and preservation of wealth.</p>
        <p>With alrajhi bank Malaysia, you can invest in fine gold and at the same time, have the peace of mind that your investment will be safeguarded especially during times of economic uncertainty. Plus, alrajhi bank Malaysia Gold-i is a Shariah compliant product.</p><p>alrajhi bank Malaysia Gold-i is now available at Nationwide Branches.</p>`,
      title: "About",
    },
    features: {
      description: [
        `<span>Real</span> precious metal`,
        `<span>Easy</span> to buy & sell`,
        `Asset <span>diversification</span>`,
        `<span>Long term</span> store of value`,
      ],
      title: "Features",
    },
    benefits: {
      description: [
        `<span>Immediate cash</span> conversion`,
        `<span>Potential capital</span> appreciate`,
      ],
      title: "Benefits",
    },
    eligibilty: {
      description: [
        `Individual account holder / joint account holders (resident and non-resident) aged 18 years and above`,
        `Non-individual account holder`,
      ],
      title: "Eligibilty",
    },
    minimumPurchase: {
      description: [
        `<b>Minimum</b> purchase is 10 grams. Additional purchase is in multiple of 5 grams`,
      ],
      title: "Minimum Purchase",
    },
    footnote:
      "Footnote:<br>Gold price may fluctuate and the Bank does not guarantee any returns on investment for the buying<br> and selling of the Gold.",
  },
  goldInvest: {
    about: {
      description: `<p>GoldInvest-i (GI-i) is a non-profit bearing, Shariah-compliant gold investment account that allows you to purchase, sell,</p>
        <p>or transfer gold and convert the gold holding in your GI-i account into physical gold on a regular basis with a minimal</p>
        <p>investment amount quoted in Ringgit Malaysia and weight (gram).</p>`,
      title: "About",
    },
    benefits: {
      description: [
        `<span>Shariah-compliant</span> product`,
        `<span>Initial investment</span> as low as RM10`,
        `Enjoy hassle-free experiences to <span>safekeep</span> the physical gold`,
        `<span>Real time</span> and <span>competitve price</span> for buying and gold`,
        `Option to <span>convert</span> to physical gold`,
      ],
      title: "Benefits",
    },
    eligibilty: {
      description: [`Individual - Sole or joint account`, `Non-individual`],
      title: "Eligibilty",
    },
    shariahContract: {
      description: [`Wakalah`, `Wadi'ah`, `Bai'al sarf`],
      title: "Shariah Contract",
    },
    minimumPurchase: {
      description: [
        `Initial and subsequent purchases:`,
        `<span>Individual</span> - Minimum of RM10 worth of Gold or its equivalent in gram`,
        `<span>Non-individual</span> - Minimum of RM100 worth of Gold or its equivalent in gram`,
      ],
      title: "Minimum Purchase",
    },
  },
  unitTrust: {
    about: {
      description: `For those who are just starting out on their investment journey. It pools your money together with other investors to invest into a wide range of assets. With this, you can participate into a diversified portfolio even with small investment amount.`,
      title:
        "Unit Trust is one of the most popular managed investments that is <span>easily accessible and affordable</span>",
      image: unit_trust_intro,
    },
    partners: {
      description: [
        `Principal Asset Management Berhad`,
        `AHAM Asset Management Berhad`,
        `Manulife Investment Management (M) Berhad`,
        `BIMB Investment Management Berhad`,
        `abrdn Islamic Malaysia Sdn bhd `,
        `AmFunds Management Berhad`,
        `Nomura Asset Management Malaysia Sdn. Bhd`,
        `RHB Islamic International Asset Management Berhad`,
      ],
      title: "Our Partners",
      image: unit_trust_benefits,
      footnotes: (
        <div>
          For the full list of unit trusts offerings, please click{" "}
          <Link to="/unit-trust-price">here</Link>.
        </div>
      ),
      subtitle:
        "alrajhi bank Malaysia distributes a wide range of Islamic Unit Trusts from the following Fund Managers:",
    },
    question: {
      description:
        'You can ascertain whether any of our staff whom you are dealing with are qualified individuals for purposes of investment or contribution into unit trusts are registered with FIMM as Consultants by accessing the link here <a href="https://www.fimm.com.my/search/">Is My Consultant Authorised?</a>',
      title: "Is My Consultant Authorised",
    },
    disclaimer: {
      description: `<p>The contents of this website do not constitute a recommendation, offer or invitation to invest in any unit trust products.</p>
      <p>No representation or warranty, expressed or implied, is made that such information or Opinions is accurate, complete or verified and should not be relied on as such. Information and Opinions contained herein are published for recipients' reference only.</p>
      <p>As with any other form of financial product, the financial product introduced herein carries risks, and you may not get back the amount you originally invested. You should be aware that this financial product may not be suitable for potential investors who are averse to such risks, and to consider the fees and charges involved.The price of units and distribution payable, if any, may increase or decrease. The returns are not guaranteed and customer risks earning no returns at all. Past performance is not an indication of future performance.</p>
      <p>You are advised to read and understand the approved relevant documents accompanying and relating to the product (whether prospectuses, information memorandum, product highlight sheet or deed) for inherent risks of investing in the product. If in doubt, potential investors should seek independent advice.</p>
      <p>Unit trust schemes are not protected by Perbadanan Insurans Deposit Malaysia (“PIDM”); and any money withdrawn from an insured deposit for the purpose of purchasing any units in a unit trust scheme is no longer protected by PIDM.</p>`,
      title: "Disclaimer",
    },
  },
  sinarKasih: {
    about: {
      description: `<p>Ensure essential coverage for your critical years to secure your family financial future and your business continuity.</p>`,
      title: "About",
    },
    features: {
      description: [
        `<span>Safeguard</span><p>Safeguard your critical years</p>`,
        `<span>Affordable</span><p>Affordable & level1 contribution</p>`,
        `<span>Coverage</span><p>Principle</p>`,
        `<span>Safeguard Business</span><p>Principle</p>`,
      ],
      footnotes:
        "*Contribution rate is not guaranteed. The Takaful Provider reserves the right to revise the contribution by giving 90 days' written notice.",
    },
    benefits: {
      description: [
        `<div>
          <div><strong>Death/Total and Permanent Disabilty (TPD<sub>2</sub>)</strong> Benefit</div>
          <br/>
          <ul>
            <li style="font-size:14px" className="text-grey-color">In the event of death/TPD of the person covered, 100% of the sum covered, less any indebtedness, will be payable in one lump sum.</li>
          </ul>
        </div>`,
        `<div>
          <div><strong>Accidental Death/TPD</strong> Benefit<sub>3</sub></div>
          <br/>
          <ul>
            <li style="font-size:14px" className="text-grey-color">An additional 50% of the sum covered will be payable if the person covered dies or suffers TPD due to accidental causes.</li>
          </ul>
        </div>`,
        `<div>
          <div><strong>Disability Allowance</strong> Benefit<sub>4</sub></div>
          <br/>
          <ul>
            <li style="font-size:14px" className="text-grey-color">An additional 3% of the sum covered will be payable in addition to TPD/accidental TPD benefit.</li>
          </ul>
        </div>`,
      ],
      footnotes: `
        <ul>
          <li className="my-3"><sub>2</sub>TPD coverage will cease on the contract monthly anniversary, immediately following the person covered's 65th birthday. Maximum TPD benefit payable is RM8,000,000 per person and industry.</li>
          <li className="my-3"><sub>3</sub>Additional death/TPD benefit due to accidental causes will cease on the contract monthly anniversary, immediately following the person covered's 65th birthday. Maximum accidental death/TPD benefit payable is RM1,000,000 per person.</li>
          <li className="my-3"><sub>4</sub>Disability allowance benefit will cease on the contract monthly anniversary, immediately following the person covered’s 65th birthday. Maximum disability allowance benefit payable is RM30,000 per person.</li>
        </ul>
      `,
      title: "Benefits",
    },
    eligibilty: {
      description: [`18-60 years old (based on age last birthday)`],
      title: "Eligibilty",
    },
  },
  sinarLinkAiman: {
    about: {
      description: `<p>SinarLink Aiman is a regular contribution investment-linked takaful plan that provides the comprehensive coverage as follows: </p>`,
      title: "About",
    },
    features: {
      description: [
        `<span>Potential Investment</span><p>Enjoy potential investment return with a wide range of Shariah-compliant investment opportunities</p>`,
        `<span>Coverage</span><p>Comprehensive coverage that comes with protection and a wide range of 6 optional riders.</p>`,
        `<span>Flexibility</span><p>Flexibility to choose different contract term options</p>`,
        `<span>Benefit</span><p>Final benefit</p>`,
      ],
      footnotes:
        "*Contribution rate is not guaranteed. The Takaful Provider reserves the right to revise the contribution by giving 90 days' written notice.",
    },
    benefits: {
      description: [
        `<span>Freedom & flexibility</span> in managing your investment fund(s)`,
        `<span>Customizable</span> all-in-one benefits`,
        `<span>Flexibilty to choose</span> different contract term options`,
        `Final <span>benefit</span>`,
      ],
      title: "Benefits",
    },
    eligibilty: {
      description: [
        `Entry age (age last birthday basis):`,
        `For person covered:`,
      ],
      terms: [
        `<div className="mt-4">*The maximum entry age for TPD coverage is 64 years old.</div>`,
        `<div className="mt-4"><p>For contract holder:</p></div>`,
        `<p>The minimum entry age is 18 years old.</p>`,
        `<div className="mt-4"><p>This product is managed by Sun Life Malaysia Takaful Berhad (689263-M), (“Sun Life Malaysia”), a Takaful Operator registered under the Islamic Financial Services Act 2013 and regulated by Bank Negara Malaysia.</p></div>`,
        `<p>Disclaimer: The description of the features and benefits of the takaful product herein is not a contract/certificate of family takaful and is only a brief summary of the takaful product for quick and easy reference. The complete terms and conditions of the takaful product are contained in the Contract/Certificate Document of SinarLink Aiman, the takaful product of Sun Life Malaysia.</p>`,
        `<p>The Shariah Board of Al-Rajhi Bank does not review or recommend any of Takaful operators including their products and other related agreements. The Shariah compliance status of Takaful products is at the responsibility of their respective Shariah Committee.</p>`,
        `<p>The Product Disclosure Sheet below is generated for a non-smoker male aged 35 years old; with sum covered of RM150,000 and coverage term up to 70 years old.</p>`,
      ],
      title: "Eligibilty",
    },
  },
  sinarBaraqah: {
    about: {
      description: `<p>Sinar Baraqah offers a comprehensive solution of takaful protection for you and your loved ones. Grow your savings from as low as RM125 monthly to help expedite your hajj obligations as well as Badal Hajj.</p>`,
      title: "About",
    },
    features: {
      description: [
        `<span>Death & Total and Permanent disability (TPD benefit*)</span><p>In the event of death or TPD of person covered, 100% of sum covered and value of Universal Account.</p>`,
        `<span>Special Payout</span><p>A lump sum amount of RM1,500 will be payable after completion of 3 contract anniversarries.</p>`,
        `<span>Final Benefit</span><p>Accumulated value of Universal Account will be payable at the end of the contract term.</p>`,
        `<span>Universal Account</span><p>While the contract is in force, the investment income will be credited to the universal account on an annual basis.</p>`,
      ],
    },
    benefits: {
      description: [
        `<li>Sinar Baraqah has a variety of contribution plan ranging from as low as RM125 monthly to enable you to reach your goal within the desired time frame.</li>`,
        sinar_baraqah_benefit,
        `<li>Death & Total and Permanent disability (TPD benefit*) - In the event of death or TPD of person covered, 100% of sum covered and value of Universal Account, less any indebtedness will be payable in one lump sum. Additional of 100% sum covered will be payable if death/TPD occurs while performing Hajj/Umrah**.</li>`,
        `<li>Accidental Death & TPD benefit* - An additional benefit amount of RM10,000 will be payable if the person covered dies or suffers TPD due to a covered accident.</li>`,
        `<li>In the event of death, suffers TPD* or diagnosed with any 36 CI of person covered, the Badal Hajj benefit will be payable to the service provider engaged by Sun Life Malaysia Takaful to perform Badal Hajj on behalf of the person covered. Should a 3rd party service provider be unavailable to perform Badal Hajj, a lump sum amount of RM2,500 will be payable to the nominee or proper claimant.</li>`,
        `<li>Special Payout - A lump sum amount of RM1,500 will be payable after completion of 3 contract anniversaries from the Universal Account.</li>`,
        `<li>Final Benefit - Accumulated value of Universal Account will be payable at the end of the contract term.</li>`,
        `<li>Universal Account - While the contract is in force, the investment income will be credited to the universal account on an annual basis. Any investment loss in the universal account will be borne by the participants.</li>`,
        `<li>Attachable Riders:
          <ol className="alpha">
            <li className="my-4">Person covered waiver of contribution benefit (PCWOC) rider***<br>This rider waives all future contributions (basic takaful contribution and scheduled top-up contribution (if any)) until the expiry of the basic plan contract term  upon diagnosis of any of the 36 critical illnesses of the person covered.</li>
            <li className="my-4">Contract holder waiver of contribution benefit (CHWOC) rider***<br>In the event that the contract holder dies, suffers total and permanent diability or is diagnosed with any one of the 36 critical illnesses, all future contributions (basic takaful contribution and scheduled top - up contribution (if any), plus riders contribution (if any)) for the contract will be waived until the expiry of rider term.</li>
          </ol>
        </li>`,
        `<li>Top up contribution:-
          <ol>
            <li className="my-4">
              Scheduled top-up contributions
              <br>Minimum: RM50 monthly
              <br>Maximum: Subject to company discretion
            </li>
            <li className="my-4">
              Single top-up contribution<br>Minimum: RM500
              <br><p>Maximum: Subject to company discretion</p>
              <br><p>The maximum scheduled top - up contribution allowable at new business stage on per contract basis is 20 times of basic sum covered.</p>
              <br><p>The maximum single top-up contribution allowable after the contract is in force is RM500,000 per person covered. Sun Life Malaysia Takaful reserve the right to change the maximum limit from time to time.</p>
            </li>
          </ol>
        </li>`,
      ],
      terms: [
        `<p>* TPD coverage will cease on the contract monthly anniversary, immediately following the person covered's 65th birthday. Maximum TPD benefit payable per life is RM 2,000,000</p>`,
        `<p>**Subject to the coverage period of 45 days for Hajj and 15 days for Umrah, or the actual travel duration, whichever is shorter.</p>`,
        `<p>***For customer who has taken up both PCWOC benefit rider and CHWOC benefit rider, the CHWOC benefit rider will be terminated once the PCWOC benefit rider is activated regardless whether CHWOC benefit rider is activated earlier or not.</p>`,
        `<p>This product is managed by Sun Life Malaysia Takaful Berhad (689263-M), (“Sun Life Malaysia”), a Takaful Operator registered under the Islamic Financial Services Act 2013 and regulated by Bank Negara Malaysia.</p>`,
        `<p>Disclaimer: The description of the features and benefits of the takaful product herein is not a contract/certificate of family takaful and is only a brief summary of the takaful product for quick and easy reference. The complete terms and conditions of the takaful product are contained in the Contract/Certificate Document of SinarLink Aiman, the takaful product of Sun Life Malaysia.</p>`,
        `<p>The Shariah Board of Al-Rajhi Bank does not review or recommend any of Takaful operators including their products and other related agreements. The Shariah compliance status of Takaful products is at the responsibility of their respective Shariah Committee.</p>`,
        `<p>The Product Disclosure Sheet below is generated for a non-smoker male aged 35 years old; with sum covered of RM150,000 and coverage term up to 70 years old.</p>`,
      ],
      title: "Features & Benefits",
    },
    knowledge: {
      title: "Do You Know?",
      subtitle:
        "Performing Hajj is one of the obligations <span>to be fulfilled by Muslims and is one of the 5 pillars of Islam.</span>",
      description: [
        `RM9,980 subsidised cost for first time pilgrimage`,
        `0.1% quota for Malaysians`,
        `89 years - current waiting period`,
        `RM40,000 - RM216,000 varied cost for pilgrimage`,
      ],
      image: hajj_knowledge,
    },
    eligibilty: {
      description: [
        `Entry age (age last birthday basis):`,
        `For person covered:`,
      ],
      terms: [
        `<div className="mt-4">*The maximum entry age for TPD coverage is 64 years old.</div>`,
        `<div className="mt-4"><p>For contract holder:</p></div>`,
        `<p>The minimum entry age is 18 years old.</p>`,
        `<div className="mt-4"><p>This product is managed by Sun Life Malaysia Takaful Berhad (689263-M), (“Sun Life Malaysia”), a Takaful Operator registered under the Islamic Financial Services Act 2013 and regulated by Bank Negara Malaysia.</p></div>`,
        `<p>Disclaimer: The description of the features and benefits of the takaful product herein is not a contract/certificate of family takaful and is only a brief summary of the takaful product for quick and easy reference. The complete terms and conditions of the takaful product are contained in the Contract/Certificate Document of SinarLink Aiman, the takaful product of Sun Life Malaysia.</p>`,
        `<p>The Shariah Board of Al-Rajhi Bank does not review or recommend any of Takaful operators including their products and other related agreements. The Shariah compliance status of Takaful products is at the responsibility of their respective Shariah Committee.</p>`,
        `<p>The Product Disclosure Sheet below is generated for a non-smoker male aged 35 years old; with sum covered of RM150,000 and coverage term up to 70 years old.</p>`,
      ],
      title: "Eligibilty",
    },
  },
  sinarHealthPlan: {
    about: {
      description: `<p>Sinar Health Plan is a Surplus Sharing Group Medical and Health Takaful Plan which provides fixed benefit for hospitalization, surgery and covered critical illness up to RM 1 million overall lifetime limit* There are 3 different plans to choose that suit your budget and lifestyle.</p>`,
      title: "About",
    },
    features: {
      description: [
        `<span>Death & Total and Permanent disability (TPD benefit*)</span><p>In the event of death or TPD of person covered, 100% of sum covered and value of Universal Account.</p>`,
        `<span>Special Payout</span><p>A lump sum amount of RM1,500 will be payable after completion of 3 contract anniversarries.</p>`,
        `<span>Final Benefit</span><p>Accumulated value of Universal Account will be payable at the end of the contract term.</p>`,
        `<span>Universal Account</span><p>While the contract is in force, the investment income will be credited to the universal account on an annual basis.</p>`,
      ],
    },
    benefits: {
      description: [
        `Fixed benefits <span>up to RM1 million</span> (overall lifetime limit*) payable in addition to any medical and health plan you already have.`,
        `Fixed benefits <span>to pay for additional charges</span> before and after hospitalization (co-takaful charges)`,
        `Fixed benefits <span>for further treatment</span> at private clinics/hospitals.`,
        `Option <span>to extend the coverage</span> for your family member`,
        `<span>No medical check-ups required</span> until 74 years old for renewals coverage.`,
      ],
      title: "Benefits",
    },
    knowledge: {
      title: "Why You Need Sinar Health Plan?",
      image: sinar_health_plan,
    },
    plan: {
      title: "Plan and Benefit",
      image: sinar_health_plan_table,
      terms: [
        `<p>This product is managed by Sun Life Malaysia Takaful Berhad (689263-M), (“Sun Life Malaysia”), a Takaful Operator registered under the Islamic Financial Services Act 2013 and regulated by Bank Negara Malaysia.</p>`,
        `<p>Disclaimer: The description of the features/plans and benefits of the takaful product herein is not a contract/certificate of a family takaful product and is only a brief summary of the takaful product for quick and easy reference. The complete terms and conditions of the takaful product are contained in the relevant Contract/Certificate Document of the specific takaful product of Sun Life Malaysia.</p>`,
        `<p>The Shariah Board of Al-Rajhi Bank does not review or recommend any of Takaful operators including their products and other related agreements. The Shariah compliance status of Takaful products is at the responsibility of their respective Shariah Committee.</p>`,
        `<p>The Product Disclosure Sheets (PDS) below are generated for a non-smoker male aged 35 years old.</p>`,
      ],
    },
    eligibilty: {
      description: [
        `Entry age (age last birthday basis):`,
        `For person covered:`,
      ],
      terms: [
        `<div className="mt-4">*The maximum entry age for TPD coverage is 64 years old.</div>`,
        `<div className="mt-4"><p>For contract holder:</p></div>`,
        `<p>The minimum entry age is 18 years old.</p>`,
        `<div className="mt-4"><p>This product is managed by Sun Life Malaysia Takaful Berhad (689263-M), (“Sun Life Malaysia”), a Takaful Operator registered under the Islamic Financial Services Act 2013 and regulated by Bank Negara Malaysia.</p></div>`,
        `<p>Disclaimer: The description of the features and benefits of the takaful product herein is not a contract/certificate of family takaful and is only a brief summary of the takaful product for quick and easy reference. The complete terms and conditions of the takaful product are contained in the Contract/Certificate Document of SinarLink Aiman, the takaful product of Sun Life Malaysia.</p>`,
        `<p>The Shariah Board of Al-Rajhi Bank does not review or recommend any of Takaful operators including their products and other related agreements. The Shariah compliance status of Takaful products is at the responsibility of their respective Shariah Committee.</p>`,
        `<p>The Product Disclosure Sheet below is generated for a non-smoker male aged 35 years old; with sum covered of RM150,000 and coverage term up to 70 years old.</p>`,
      ],
      title: "Eligibilty",
    },
  },
  structuredProduct: {
    about: {
      description: `<p>A Structured Product-i is an investment product linked to a reference and is intended to provide a potentially higher return than a normal term deposit-i. A Structured Product-i may be linked to the performance of a currency, a rate, an equity security, an index or other underlying asset.</p>`,
      title: "About",
    },
    benefits: {
      description: [
        `Provides the investor an option to gain exposure to various <span>asset classes</span>, whilst at the same time <span>protecting the downside.</span>`,
        `<span>Offers payment</span> of full principal amount if held until maturity.`,
        `Investor may receive <span>enhanced return</span>, which is <span>higher</span> than the return offered by term deposit-i.`,
      ],
      title: "Benefits",
      subtitle:
        "alrajhi bank Malaysia offers principal-protected Structured Product-i, which:",
    },
    eligibilty: {
      description: [
        `Individual account holder / joint account holders (resident and non-resident) aged eighteen (18) years and above on the application date`,
        `Non-individual account holder`,
      ],
      title: "Eligibilty",
    },
    getStarted: {
      description: [
        `<p>Speak to your Relationship Manager or visit your nearest alrajhi bank Malaysia branch to apply.</p>`,
        `<br>
          WARNING<br>
          THE RETURNS ON YOUR STRUCTURED PRODUCT WILL BE AFFECTED BY THE PERFORMANCE OF THE UNDERLYING ASSET / REFERENCE. THE RECOVERY OF YOUR PRINCIPAL INVESTMENT MAY BE JEOPARDISED IF YOU MAKE AN EARLY REDEMPTION. THIS STRUCTURED PRODUCT IS NOT PROTECTED BY PIDM. THIS IS NOT A BANK DEPOSIT. YOUR STRUCTURED PRODUCT IS SUBJECT TO INVESTMENT RISKS. DO NOT INVEST UNLESS YOU FULLY UNDERSTAND AND ARE WILLING TO ACCEPT THESE RISKS. YOU SHOULD OBTAIN INDEPENDENT ADVICE.`,
      ],
      title: "Get Started with <br>Structure Product-i",
    },
    knowledge: {
      title: "Why You Need Sinar Health Plan?",
      image: sinar_health_plan,
    },
    plan: {
      title: "Plan and Benefit",
      image: sinar_health_plan_table,
      terms: [
        `<p>This product is managed by Sun Life Malaysia Takaful Berhad (689263-M), (“Sun Life Malaysia”), a Takaful Operator registered under the Islamic Financial Services Act 2013 and regulated by Bank Negara Malaysia.</p>`,
        `<p>Disclaimer: The description of the features/plans and benefits of the takaful product herein is not a contract/certificate of a family takaful product and is only a brief summary of the takaful product for quick and easy reference. The complete terms and conditions of the takaful product are contained in the relevant Contract/Certificate Document of the specific takaful product of Sun Life Malaysia.</p>`,
        `<p>The Shariah Board of Al-Rajhi Bank does not review or recommend any of Takaful operators including their products and other related agreements. The Shariah compliance status of Takaful products is at the responsibility of their respective Shariah Committee.</p>`,
        `<p>The Product Disclosure Sheets (PDS) below are generated for a non-smoker male aged 35 years old.</p>`,
      ],
    },
  },
  willWriting: {
    about: {
      description: `<p>The fruits of your life-long labour should be appreciated by the ones you love most. To preserve your inheritance for future generations and ensure a fair distribution of your family fortunes, alrajhi bank Malaysia offers professional and experienced Estate Planning services. At alrajhi bank Malaysia, a high degree of care goes into helping you strategically plan ahead and maintain peace of mind.</p>
        <br>Who Can Apply<br>
        Anyone who is 18 years of age or older and of sound mind can make a Will. In partnership with MyAngkasa Amanah Berhad / Amanah Raya / As-Salihin Trustee, alrajhi bank Malaysia provides professional standard Will Writing, custodianship and execution services at a reasonable fee.`,
      title: "About",
    },
    benefits: {
      description: [
        `<span>Secures the future</span> of your loved ones in their time of need`,
        `Avoids family disputes over <span>rights of ownership</span> to the estate`,
        `Ensures your assets are distributed to your <span>chosen beneficiaries</span> in the manner you desire (For Non-Muslim Only)`,
        `Names a <span>trusted Guardian</span> to take care of your children`,
        `Appoints an <span>Executor</span> to carry out the terms of your Will`,
      ],
      title: "Benefits",
    },
    services: {
      description: [
        `<strong>Will Writing:</strong> Expeditious Will preparation for both Muslims and Non-Muslims`,
        `<strong>Custodial Services:</strong> Safekeeping of your Will to ensure strict confidentiality & prevent fraud/tampering.`,
        `<strong>Execution:</strong> As your Executor, MyAngkasa Amanah Berhad / Amanah Raya / As-Salihin Trustee can further expedite and speed up the settlement of your estate and the distribution of assets.`,
      ],
      title: "Eligibilty",
    },
    collaboration: {
      description: [
        `MyAngkasa Amanah Berhad`,
        `Amanah Raya Berhad`,
        `As-Salihin Trustee Berhad`,
      ],
      title:
        "We are in <br>collaboration<br> with the<br> following Estate<br> Planning providers:",
    },
  },
  safeDepositBox: {
    about: {
      description: `<p>A secure, confidential and professional service that allows you to deposit your valuables and documents with complete peace of mind.</p>
        <br>Our facilities are located at selected branches in major cities of Malaysia, where professional staff are always at hand to ensure that your use of the facilities is both carefree and confidential.`,
      title: "About",
    },
    benefits: {
      description: [
        `<span>Safeguard</span> your irreplaceable and valuable items`,
        `Available in <span>five different sizes</span>`,
        `<span>Free Takaful Coverage</span> of up to RM 10,000`,
        `Easy and convenient <span>accessed</span> by you only`,
      ],
      title: "Benefits",
    },
    features: {
      description: [
        `Dual Key System`,
        `Safe Deposit Box can only be opened by turning both keys at the same time. Therefore, all access by customers will be identified by the Bank's officer to ensure the rightful owner to the Safe Deposit Box.`,
      ],
      title: "Features",
    },
    rates: {
      branches: [
        {
          branch: "Bangsar Affluent & KL Branch",
          table: safe_deposit_box_KL_rates,
        },
        { branch: "Kota Kinabalu branch", table: safe_deposit_box_KK_rates },
        { branch: "Ipoh Branch", table: safe_deposit_box_ipoh_rates },
        { branch: "Other Charges", table: safe_deposit_box_other_charges },
      ],
      title: "Rates & Charges",
    },
  },
};

export default wealth;
